/**
 * Created by chenrozenes on 17/10/2017.
 */

export const getTaxonomies = state => state.directory.autoCompleteProvider.taxonomies;
export const getPhysicians = state => state.directory.autoCompleteProvider.physicians;
